module.exports = __webpack_public_path__ + "img/delete_gray.a66e7e5f.svg";